function t(t,n){"function"==typeof t?t(n):t&&(t.current=n)}export{t as default};
//# sourceMappingURL=setRef.js.map
